module.exports = __webpack_public_path__ + "img/proigoumeno.59f88c7c.svg";